<template>
  <div>
    <dashboard-page-title @addEvent="$router.push({name: 'addProduct'})" :showAddBtn="false">المراجعات</dashboard-page-title>

    <main-table :fields="fields" list_url="merchant/reviews" paginationName="المراجعات"></main-table>
  </div>
</template>
<script>
import { core } from '@/config/pluginInit'
export default {
  components: {},
  mounted () {
    core.index()
  },
  data () {
    return {
      fields: [
        { label: 'صوره المنتج', key: 'product.featured_image', class: 'text-start', type: 'image' },
        { label: 'اسم المنتج', key: 'product.name', class: 'text-start' },
        { label: 'اسم المتجر', key: 'store.name', class: 'text-start' },
        { label: 'التعليق', key: 'comment', class: 'text-start' },
        { label: 'التقييم', key: 'star', class: 'text-start' },
        { label: 'االحالة', key: 'status', class: 'text-start', type: 'status', objectTranslation: 'main.status' },
        { label: 'Created At', key: 'created_at', class: 'text-start' }
      ]
    }
  },
  methods: {
    addMerchant () {
      console.log('hello')
    }
  }
}
</script>
